export default function ProcessSection() {
  const steps = [
    {
      num: '01',
      title: 'On-going Onsite Visits',
      desc: 'I act as your eyes in China, present when it matters most, and reporting back exactly what’s happening on the factory floor.',
      img: 'https://public.readdy.ai/ai/img_res/41f644b2-c50c-4171-b5a9-44c4bae5d128.png',
      alt: 'Unannounced factory visit - on-site quality inspection China',
    },
    {
      num: '02',
      title: 'Checking What Really Matters',
      desc: 'Quality check, workers conditions, real insights. You define the priorities, I verify them on-site, giving you honest feedback that goes beyond what the factory wants you to see.',
      img: 'https://public.readdy.ai/ai/img_res/353381e5b77db63c8b1c4ad5aeec9677.jpg',
      alt: 'Quality inspection - detailed fabric and material assessment',
    },
    {
      num: '03',
      title: '48-Hour Visual Report',
      // Escaped the apostrophe to avoid syntax error
      desc: 'No boring PDF\'s. I capture what truly matters on the factory floor and deliver it within 48 hours. Honest visuals you can use internally or externally, keeping your brand safe and credible.',
      img: 'https://readdy.ai/api/search-image?query=modern-tablet-device-displaying-professional-factory-inspection-report-with-photographs-and-data-charts-clean-interface-design-placed-on-minimal-desk-workspace-overhead-view-professional-product-photography-soft-natural-lighting&width=640&height=440&seq=process-report-03&orientation=landscape',
      alt: 'Visual factory report - 48-hour delivery with photos and video',
    },
  ];

  return (
    <section id="process" className="py-28 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-20">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-8 h-[1px] bg-[#D98C74]"></span>
            <span className="text-[#D98C74] text-[12px] font-semibold tracking-[0.2em] uppercase">The Process</span>
            <span className="w-8 h-[1px] bg-[#D98C74]"></span>
          </div>
          <h2 className="text-[30px] lg:text-[40px] font-bold text-[#2C3E50] leading-[1.15] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            The Power of Presence
          </h2>
          <p className="text-[#2C3E50]/60 text-[16px] leading-[1.7]">
            I am your eyes, ears, and conscience in China. Here's how I protect your brand, month after month.
          </p>
        </div>

        <div className="space-y-16">
          {steps.map((step, i) => (
            <div
              key={step.num}
              className={`flex flex-col ${i % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-10 items-center`}
            >
              <div className="w-full lg:w-1/2">
                <div className="w-full h-[300px] lg:h-[340px] rounded-lg overflow-hidden">
                  <img
                    src={step.img}
                    alt={step.alt}
                    title={step.alt}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-4 mb-5">
                  <span className="text-[48px] font-bold text-[#D98C74]/20" style={{ fontFamily: "'Playfair Display', serif" }}>{step.num}</span>
                  <span className="w-8 h-[1px] bg-[#D98C74]"></span>
                </div>
                <h3 className="text-[24px] lg:text-[28px] font-bold text-[#2C3E50] mb-4">{step.title}</h3>
                <p className="text-[#2C3E50]/60 text-[15px] leading-[1.8] max-w-md">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}